<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="720px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      v-loading="loading"
      :model="ruleForm"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="考试科目："
        prop="subjectId">
        <subject-select
          :value="ruleForm.subjectId"
          style="width: 100%"
          @change="onSubjectChange" />
      </el-form-item>
      <el-form-item
        label="考试名称："
        prop="examName">
        <el-input v-model="ruleForm.examName"></el-input>
      </el-form-item>
      <el-divider>考试内容</el-divider>
      <el-form-item
        label="考卷分数："
        prop="paperId">
        <custom-select-icon
          :propsValue="ruleForm.paperName"
          @select="selectPaper">
          <b>考卷：</b><span>{{ ruleForm.paperName }}</span>，
          <b>总分：</b><span>{{ ruleForm.paperScore }}分</span>，
          <b>答题时间：</b><span>{{ ruleForm.examMinutes }}分钟</span>
        </custom-select-icon>
      </el-form-item>
      <el-form-item
        :label="ruleForm.secondScoreName+'：'"
        prop="secondScore">
        <el-input-number
          v-model="ruleForm.secondScore"
          :min="0"
          :max="200"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item
        :label="ruleForm.thirdScoreName+'：'"
        prop="thirdScore">
        <el-input-number
          v-model="ruleForm.thirdScore"
          :min="0"
          :max="200"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item
        label="通过分数："
        prop="passingScore">
        <div style="display: flex;">
          <span>考试总分为：<b>{{ totalScore }}</b>分，</span>
          <el-input-number
            v-model="ruleForm.passingScore"
            style="width: 100px;"
            :min="0"
            :max="totalScore"
            :controls="false"
            :precision="0"></el-input-number>
          <span>通过</span>
        </div>
      </el-form-item>
      <el-form-item
        label="考试时间："
        prop="rangeTime">
        <el-date-picker
          popper-class="hide-panel-clear"
          :value="ruleForm.rangeTime"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm"
          :picker-options="begintTimeoptions"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :clearable="false"
          :editable="false"
          :default-time="['09:00:00', '11:00:00']"
          @input="onChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="立即发布："
        prop="status">
        <el-switch
          v-model="ruleForm.status"
          :active-value="5"
          :inactive-value="4">
        </el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>

    <examination-paper-select-modal
      ref="paper"
      @select="handlePaperSelect" />
  </el-dialog>
</template>
<script>
import CustomSelectIcon from '../../../../components/custom-select-icon.vue'
import ExaminationPaperSelectModal from '../../examination-paper-select-modal.vue'
import SubjectSelect from '../../subject-select.vue'
import moment from 'moment'
export default {
  name: 'ExaminationModal',
  components: { SubjectSelect, CustomSelectIcon, ExaminationPaperSelectModal },
  props: {
    callback: { type: Function, default() {} }
  },
  data() {
    return {
      loading: false,
      visible: false,
      value2: '',
      ruleForm: {
        id: null, examName: '', subjectId: null, rangeTime: null, status: 4, passingScore: 0,
        secondScoreName: '平时分数', secondScore: 0, thirdScoreName: '操作分数', thirdScore: 0,
        paperId: null, paperName: '', paperScore: 0, examMinutes: 0
      }, // beginTime: null, endTime: null,
      rules: {
        subjectId: [
          { required: true, message: '请选择考试科目', trigger: 'change' }
        ],
        examName: [
          { required: true, message: '请输入考试名称', trigger: 'blur' }
        ],
        paperId: [
          { required: true, message: '请选择考卷', trigger: 'change' }
        ],
        rangeTime: [
          { required: true, message: '请选择考试时间', trigger: 'blur' }
        ]
      },
      begintTimeoptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }

      }
    }
  },
  computed: {
    title({ ruleForm }) {
      return (ruleForm.id ? '编辑' : '新增') + '考试'
    },
    totalScore({ ruleForm }) {
      const { paperScore, secondScore, thirdScore } = ruleForm
      return (paperScore || 0) + (secondScore || 0) + (thirdScore || 0)
    }
  },
  // watch: {
  //   'ruleForm.beginTime': {
  //     handler(newValue, oldValue) {
  //       const dateTime = moment().format('YYYY-MM-DD HH:mm:ss') // 当前时间
  //       const dt = dateTime.split(' ')
  //       let minTime = ''
  //       // 是今天,选择 的时间开始为此刻的时分秒
  //       console.log(newValue, '----', oldValue, '---', dateTime)
  //       if (newValue.split(' ')[0] === dt[0]) {
  //         minTime = dt[1]
  //         if (!oldValue) {
  //           this.ruleForm.beginTime = dateTime
  //         } else if (newValue.split(' ')[0] !== oldValue.split(' ')[0]) {
  //           this.ruleForm.beginTime = dateTime
  //         }
  //       } else {
  //         minTime = '00:00:00'
  //       }
  //       this.selectableRange = minTime + ' - 23:59:59'
  //     }
  //   }
  // },
  watch: {
    totalScore(val) {
      this.ruleForm.passingScore = Math.min(this.ruleForm.passingScore, val)
    }
  },
  methods: {
    onChange(e) {
      // const begin = moment(e[0])
      // const end = moment(e[1])
      // const examMinutes = this.ruleForm.examMinutes
      // const diffMinutes = moment(end).diff(moment(begin), 'minutes')
      // if (diffMinutes < examMinutes) {
      //   this.$message.error('考试时间范围必须大于等于考卷答题时间')
      //   return
      // }
      // if (begin < moment()) {
      //   this.$message.error('考试开始时间必须大于当前时间')
      //   return
      // }
      if (this.validateTime(e)) {
        this.ruleForm.rangeTime = e
      }
    },
    selectPaper() {
      if (!this.ruleForm.subjectId) {
        this.$message.error('请先选择考试科目')
        return
      }
      this.$refs.paper.fetch()
    },
    handlePaperSelect(row) {
      // console.log(row)
      this.ruleForm = { ...this.ruleForm, ...row }
    },
    onSubjectChange(e) {
      this.ruleForm.subjectId = e
      this.ruleForm = {
        ...this.ruleForm, paperId: null, paperName: '', paperScore: 0, examMinutes: 0, rangeTime: null, passingScore: 0
      }
    },
    handleClosed() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
    },
    validateTime(e) {
      const begin = moment(e[0])
      const end = moment(e[1])
      const examMinutes = this.ruleForm.examMinutes
      const diffMinutes = moment(end).diff(moment(begin), 'minutes')
      if (diffMinutes < examMinutes) {
        this.$message.error('考试时间范围必须大于等于考卷答题时间')
        return false
      }
      if (begin < moment()) {
        this.$message.error('考试开始时间必须大于当前时间')
        return false
      }
      return true
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const { id, rangeTime } = this.ruleForm
          if (!this.validateTime(rangeTime)) {
            return
          }
          this.loading = true
          const dispatch = id ? 'updateexam' : 'addexam'
          const [beginTime, endTime] = rangeTime
          this.$$examApi[dispatch]({ ...this.ruleForm, beginTime: +beginTime, endTime: +endTime, rangeTime: null, totalScore: this.totalScore })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.loading = false
                this.visible = false
                this.$message.success((id ? '更新' : '新增') + '成功')
                this.callback && this.callback()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    init(options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      this.visible = true
    }
  }
}
</script>
